import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { fetchUserDashboardAPI } from '../../api/userDashboardApis/user-dashboard.api';

export const useUserDashboard = () => {
  const navigate = useNavigate();
  
  const [profile, setProfile] = useState<any>(null);
  const [stats, setStats] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // 🟢 Wrapped the fetching logic in useCallback so it can be called externally
  const loadDashboardData = useCallback(async () => {
    setIsLoading(true);
    const userCode = localStorage.getItem('user_code');

    if (!userCode) {
      toast.error('Session expired or not found. Please login again.');
      setIsLoading(false);
      navigate('/user-login'); 
      return;
    }

    try {
      const response = await fetchUserDashboardAPI(userCode);
      
      // 🟢 EXACT MAPPING: Using the precise keys returned by your NestJS backend
      const userProfile = response.data.profile;
      
      setProfile(userProfile);
      localStorage.setItem(
  'has_used_first_offer',
  String(userProfile?.hasUsedFirstOffer)
);
      setStats(response.data.stats);

      // Sync strictly with local storage for the Chat Room and Intake Modal
      const photoUrl = userProfile?.profilePhotoUrl;
      const userName = userProfile?.name;

      if (photoUrl) {
        localStorage.setItem('userProfileImage', photoUrl);
      } else {
        // Clean up just in case the user deleted their photo from the database
        localStorage.removeItem('userProfileImage'); 
      }

      if (userName) {
        localStorage.setItem('userName', userName);
      }

    } catch (err: any) {
      console.error("Error loading dashboard", err);
      const errorMessage = err.response?.data?.message || 'Failed to load dashboard data';
      setError(errorMessage);
      toast.error(errorMessage);
      
      localStorage.removeItem('user_code');
      navigate('/user-login');
    } finally {
      setIsLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    loadDashboardData();
  }, [loadDashboardData]);

  // 🟢 We return loadDashboardData as 'mutate' so components can force a refresh
  return {
    profile,
    stats,
    isLoading,
    error,
    mutate: loadDashboardData 
  };
};